import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { T } from 'shared/helper/translate';
import { ACCESS_TYPE } from '../constants';
var DigitalEditingHeader = function DigitalEditingHeader(_ref) {
  var busy = _ref.busy,
    accessType = _ref.accessType;
  return /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "pb-0 mb-2"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Digital Editing"
  }), /*#__PURE__*/React.createElement("span", {
    className: "ms-2 badge ".concat(accessType === ACCESS_TYPE.NONE ? 'bg-warning' : 'bg-success', " rounded text-white text-small align-middle")
  }, /*#__PURE__*/React.createElement(T, {
    source: "digital-editing-badge-".concat(accessType)
  })), busy ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "ms-2 text-muted",
    icon: "fa-solid fa-spinner-scale",
    spin: true
  }) : null)));
};
export default DigitalEditingHeader;